import React,{useState,useEffect} from 'react'
import {
    Avatar ,
    Progress,
    Input ,
    Divider,
    Typography ,
    Button,
    Alert,
    Popconfirm,
    Modal
} from 'antd'
import { MailOutlined ,MobileOutlined} from '@ant-design/icons';
import {useSelector,useDispatch} from 'react-redux'
import firebaseApp from '../../../firebase'
import firebase from 'firebase'
import OtpInput from "react-otp-input";

const { Text } = Typography;

export default function Profile() {
    const user = useSelector(state=>state.user)
    const dispatch = useDispatch()
    const [percent,setPercent] = useState(0)
    const [displayName,setDisplayName] = useState(null)
    const [email,setEmail] = useState(null)
    const [number,setNumber] = useState(null)
    const [error,setError] = useState(false)
    const [visible,setVisible] = useState(false)
    const [OTP,setOTP] = useState(null)
    const [verificationId,setVerificationId] = useState(null)
    const [cred,setCred] = useState(null)
    useEffect(()=>{
            var p = 0;
            if(user.email!==null ){
                p+=4;
                setEmail(user.email)
            }
            if(user.displayName!==null){
                p+=4;
                setDisplayName(user.displayName)
            }
            if(user.phoneNumber!==null){
               p+=2;
               setNumber(user.phoneNumber)
            }
            setPercent(p*10)
     
    },[])

    const submitHandler=()=>{
        if(displayName!==null){
            if(email!==null){
                if(number!==null && number.length >= 10){
                    setError(false)
                    verifyPhoneWithOTP(); 
                    return
                }
            }
        }
        setError(true)
    }
    const verifyPhoneWithOTP=()=>{
        
        var applicationVerifier = new firebase.auth.RecaptchaVerifier(
            'recaptcha-container',{'size': 'small'});
        var provider = new firebase.auth.PhoneAuthProvider();
        
        provider.verifyPhoneNumber(number, applicationVerifier)
        .then(function(verificationId) {
                setVisible(true)
                setVerificationId(verificationId)
              });
          
           
                
                
        
    }

    const verifyOTP= async()=>{
        var c = firebase.auth.PhoneAuthProvider.credential(verificationId,
            OTP)
            console.log(cred,c)
            dispatch({
                type:"UPDATE_USER_PROFILE",payload:{
                email,
                number,
                displayName,
                phoneCredential:c,
                uid:user.uid
            }
            })
       
        setVisible(false)
        setPercent(100)
    }
    return (
        <div id="profile-menu">
            <div id="profile-top">
                <Avatar  size={100} style={{ backgroundColor: "#40a9ff", verticalAlign: 'middle' }}  gap={4}>{displayName}</Avatar>
                <Progress type="circle" percent={percent} width={80}/>
            </div>
            <Divider/>
            <div id="input-data">
                
                <Text editable={{ onChange: setDisplayName }} style={{fontSize:"30px"}}>{displayName}</Text><br/>
                <Input value={email} size="large" type="email" placeholder="Enter Email Address" prefix={<MailOutlined />} onChange={(e)=>setEmail(e.target.value)}/><br/>
                <Input value={number} size="large" type="tel" placeholder="Enter Mobile Number" prefix={<MobileOutlined />} onChange={(e)=>setNumber(e.target.value)}/><br/>

              
                <Popconfirm
            title="Are you sure update the profile ?"
            onConfirm={()=>submitHandler()}
            okText="Yes"
            cancelText="No"
            disabled={user.verified}
        >
      
            <Button disabled={user.verified}>Update Profile</Button>
        </Popconfirm><br/>
        {visible?<Modal
            title="Please enter OTP"
            style={{ top: 20 }}
            visible={visible}
            onOk={() => verifyOTP()}
            onCancel={() => setVisible(false)}
            >
            <div style={{display:"flex",flexDirection:"row",justifyContent:"center",alignContent:"center"}}>
            <OtpInput
            onChange={otp => setOTP(otp)}
            numInputs={6}
            inputStyle={{width:40,height:40}}
            value={OTP}
            separator={<span>-</span>}
            />
           
        
        </div>

        </Modal>:null}
        
       

        {user.verified? <Alert message="Your Profile is verified !" type="success" showIcon />:
        null}
        <div id='recaptcha-container'></div>
        <br/>
                {error?<Alert
                    message="Error"
                    description="Please enter valid values"
                    type="error"
                    showIcon
                  />:null}
                 
            </div>
               
        </div>
    )
}
